import { getNamespacedBy } from '@/store/utils';

export const actionTypes = {
  SIGN_IN: 'signIn',
  SIGN_OUT: 'signOut',
  FETCH_USER_INFO: 'fetchUserInfo',
};

export const globalActions = getNamespacedBy('auth', actionTypes);
